import { render, staticRenderFns } from "./RateSheetDefinitionVersionSelector.vue?vue&type=template&id=c283883a&"
import script from "./RateSheetDefinitionVersionSelector.vue?vue&type=script&lang=js&"
export * from "./RateSheetDefinitionVersionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports